import { Box, Divider, Typography } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../app/hooks";
import {
  dateTimeSecondsFormat,
  shortDateFormat,
} from "../../../../common/helpers/formatDateTime";
import { Talent } from "../../../talents/talentAPI";
import TalentHrDetails from "../../talentHrRepresentative/TalentHrDetails";
import TalentInfoRow from "../TalentInfoRow";
import TalentSummaryCard from "../TalentSummaryCard";
import { BasicInfo } from "./BasicInfo";
import TalentProfilePicture, { AvatarShape } from "./TalentProfilePicture";

type Props = {
  talent: Talent;
  previewMode?: boolean;
};

const TalentBasicInfo = ({ talent, previewMode = false }: Props) => {
  const { t } = useTranslation("talentProfile");
  const { status } = useAppSelector((state) => state.talents);
  const isLoading = status === "pending";
  const memberSinceFormatted = talent.memberSince
    ? format(new Date(talent.memberSince), shortDateFormat)
    : null;
  const lastLoggedInFormatted = talent.llt
    ? format(new Date(talent.llt), dateTimeSecondsFormat)
    : null;

  return (
    <Box display="flex" alignItems="flex-start" gap="16px" mb={2}>
      <TalentProfilePicture
        talent={talent}
        avatarShape={AvatarShape.ROUNDED}
        size={200}
      />
      <TalentSummaryCard
        containerSx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "200px",
          marginBottom: "8px",
        }}
      >
        <BasicInfo talent={talent} previewMode={previewMode} />
        <Divider sx={{ mt: "8px" }} />
        <TalentHrDetails
          talent={talent}
          isLoading={isLoading}
          disableEdit={previewMode}
        />
        <Divider />
        <Box mt={-0.5} mb={-1.5}>
          <TalentInfoRow label={t("createdAt")} labelMinWidth="54px">
            <Typography>
              {memberSinceFormatted ?? t("hourEntries:notKnown")}
            </Typography>
          </TalentInfoRow>
        </Box>
        <Box mt={-1} mb={-0.5}>
          <TalentInfoRow label={t("lastActiveInApp")} labelMinWidth="54px">
            <Typography>
              {lastLoggedInFormatted ?? t("hourEntries:notKnown")}
            </Typography>
          </TalentInfoRow>
        </Box>
      </TalentSummaryCard>
    </Box>
  );
};

export default TalentBasicInfo;
